module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_shiga-577d4c3768b2373abb445e1c935638b0.png";